import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

import elementSize from './elementSize';

export default styled(Icon)`
  width: ${elementSize};
  text-align: center;
  color: #b0bdd2;
  font-size: 25px;
  line-height: 3rem;
`;
